export default __webpack_public_path__ + "static/hsdeville-roman-408eb7a197cf239481d057f2d76528a6.woff";